import React, { useMemo } from 'react';
import { useAuthContext } from '../../../context/AuthContext';
import { MOCK_ADMIN_STATS, MOCK_QUEUES, QUEUE_ORDER } from '../../mocks';

function getInitials(name?: string): string {
  if (!name) return 'U';
  return name
    .split(' ')
    .map((p) => p[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export const ForgeProfilePage: React.FC = () => {
  const { user } = useAuthContext();
  const displayName = user?.name || 'User';

  const queueNames = useMemo(() => {
    const seen = new Map<string, string>();
    for (const q of MOCK_QUEUES) {
      if (!seen.has(q.queueName)) {
        seen.set(q.queueName, q.displayName);
      }
    }
    return [...seen.entries()]
      .sort((a, b) => (QUEUE_ORDER[a[0]] ?? 99) - (QUEUE_ORDER[b[0]] ?? 99))
      .map(([, display]) => display);
  }, []);

  return (
    <div className="page-content">
      <div className="profile-card">
        <div className="profile-avatar-large">{getInitials(user?.name)}</div>
        <div className="profile-info">
          <div className="profile-name">{displayName}</div>
          <div className="profile-role">Admin</div>
          <div
            style={{
              fontFamily: 'var(--font-mono)',
              fontSize: 11,
              color: 'var(--text-tertiary)',
              marginTop: 4,
            }}
          >
            {user?.id || 'user'}
          </div>
        </div>
      </div>

      <div className="forge-card" style={{ marginBottom: 20 }}>
        <div className="forge-card-title">Queue Assignments</div>
        <table className="admin-table">
          <thead>
            <tr>
              <th>Queue</th>
            </tr>
          </thead>
          <tbody>
            {queueNames.map((name) => (
              <tr key={name}>
                <td style={{ fontWeight: 600 }}>{name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="forge-card">
        <div className="forge-card-title">Session Stats</div>
        <table className="admin-table">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {MOCK_ADMIN_STATS.map((stat) => (
              <tr key={stat.label}>
                <td style={{ fontWeight: 600 }}>{stat.label}</td>
                <td style={{ fontFamily: 'var(--font-mono)' }}>
                  {stat.format === 'percent'
                    ? `${stat.value}%`
                    : stat.format === 'time'
                      ? `${stat.value}s`
                      : stat.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
